var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDotMenu = function SvgDotMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 8,
    r: 2,
    fill: "currentColor",
    fillOpacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 2,
    fill: "currentColor",
    fillOpacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 8,
    r: 2,
    fill: "currentColor",
    fillOpacity: 0.6
  })));
};
export default SvgDotMenu;